"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));

var _TextField = _interopRequireDefault(require("../baseComponents/TextField"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var state = {
  search: ""
};

var SearchInput = /*#__PURE__*/function (_Component) {
  _inherits(SearchInput, _Component);

  var _super = _createSuper(SearchInput);

  function SearchInput(props) {
    var _this;

    _classCallCheck(this, SearchInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "resetInputFieldWidth", function () {
      if (_this.props.clearable && _this.props.autoResize) {
        if (_this.props.placeholder) _this.setState({
          width: "calc(".concat(_this.calculateInputWidth(_this.props.placeholder), " + 1ch)")
        }); // gives enough space for text to finish})
        else _this.setState({
            width: "100%"
          });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "addEventListenerToEsc", function (e) {
      if (e.keyCode == 27) {
        _this.clearSearchInput();

        _this.resetInputFieldWidth();
      }
    });

    _this.state = {
      search: props.search ? props.search : ""
    };
    _this.typingTimer = null;
    _this.handleField = _this.handleField.bind(_assertThisInitialized(_this));
    _this.clearSearchInput = _this.clearSearchInput.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SearchInput, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.addEventListenerToEsc); // Remember state for the next mount
      // Re: remembering the state is causing a problem that the seach field is preserving the search text navigating
      // between different places that has a search input, so I am commenting it now to keep track if a problem happened
      // then we might consider making this will a flag prop or something otherwise it could be removed
      // state = this.state
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('keydown', this.addEventListenerToEsc);
      this.resetInputFieldWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.placeholder !== this.props.placeholder) {
        this.resetInputFieldWidth();
      }
    }
  }, {
    key: "handleField",
    value: function handleField(e) {
      e.preventDefault();
      var val = e.target.value;
      state.search = val;

      if (this.props.inputCleanupPattern) {
        val = val.replace(RegExp(this.props.inputCleanupPattern, "g"), "");
      }

      this.setState({
        search: val
      });
      this.searchTypingTimer(val);
    }
  }, {
    key: "searchTypingTimer",
    value: function searchTypingTimer(search) {
      var _this2 = this;

      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(function () {
        if (_this2.props.onChange) {
          _this2.props.onChange(search);
        }
      }, this.props.intervalTime);
    }
  }, {
    key: "clearSearchInput",
    value: function clearSearchInput() {
      this.handleField({
        preventDefault: function preventDefault() {},
        target: {
          value: ""
        }
      });
      this.resetInputFieldWidth();
    }
  }, {
    key: "calculateInputWidth",
    value: function calculateInputWidth(value, addedChar) {
      var text = document.createElement("span");
      document.body.appendChild(text);
      text.style.height = 'auto !important';
      text.style.width = 'auto !important';
      text.style.position = 'absolute';
      text.style.whiteSpace = 'pre-wrap';
      text.innerHTML = value + addedChar;
      var width = Math.ceil(text.clientWidth);
      var formattedWidth = width + 'px';
      document.body.removeChild(text);
      return formattedWidth;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var value = this.props.controlled ? this.props.search : this.state.search;
      var classes = (0, _classnames["default"])("searchInput-component", this.props.className, this.props.fieldStyle, {
        "expendable": this.props.expendable,
        "filled": value,
        "clearable": this.props.clearable
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes,
        style: this.props.style
      }, this.props.preSearchObj && /*#__PURE__*/_react["default"].createElement("div", {
        className: "preSearch"
      }, this.props.preSearchObj), /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
        className: "search-icon",
        name: "glyph-search",
        onClick: function onClick(e) {
          e.currentTarget.nextElementSibling.querySelector("input").focus();
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "searchInput-textContainer"
      }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        customValue: this.props.customValue,
        width: this.state.width,
        name: "contentSearch",
        value: value,
        placeholder: this.props.placeholder,
        onChange: this.handleField,
        autoComplete: "off",
        onKeyDown: function onKeyDown(e) {
          if (e.keyCode == 13) {
            e.target.blur();

            if (e.target.value.length <= 1) {
              _this3.resetInputFieldWidth();

              return;
            }
          }

          if (e.keyCode == 27) {
            e.target.blur();

            _this3.clearSearchInput();

            _this3.resetInputFieldWidth();

            return;
          }

          var c = String.fromCharCode(e.keyCode | e.charCode); // that makes the value for the smalled letter 'i' and
          //largest letter 'W' looks good

          if (e.keyCode == 8 && e.target.value.length <= 1) {
            _this3.resetInputFieldWidth();

            return;
          }

          if (_this3.props.clearable && _this3.props.autoResize) {
            _this3.setState({
              width: "calc(".concat(_this3.calculateInputWidth(e.target.value, c), " + 1ch)") // gives enough space for text to finish

            });
          }
        }
      }), this.props.clearable && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])("clear-icon", {
          "hide": !value
        }),
        onClick: function onClick(e) {
          _this3.clearSearchInput();

          e.currentTarget.previousElementSibling.querySelector("input").focus();
        }
      }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
        name: "glyph-remove",
        isAction: true
      }), /*#__PURE__*/_react["default"].createElement("div", null, this.props.clearText))), this.props.postSearchObj && /*#__PURE__*/_react["default"].createElement("div", {
        className: "postSearch"
      }, this.props.postSearchObj));
    }
  }]);

  return SearchInput;
}(_react.Component);

SearchInput.Proptypes = {
  preSearchObj: _propTypes["default"].object,
  postSearchObj: _propTypes["default"].object,
  search: _propTypes["default"].string,
  expendable: _propTypes["default"].bool,
  placeholder: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  intervalTime: _propTypes["default"].number,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  clearable: _propTypes["default"].bool,
  clearText: _propTypes["default"].string,
  fieldStyle: _propTypes["default"].oneOf(["boxed", "minimalist"]),
  customValue: _propTypes["default"].object,
  autoResize: _propTypes["default"].bool,
  inputCleanupPattern: _propTypes["default"].string
};
SearchInput.defaultProps = {
  fieldStyle: "minimalist",
  search: "",
  expendable: false,
  placeholder: "",
  onChange: function onChange() {},
  intervalTime: 800,
  className: "",
  style: {},
  clearable: false,
  clearText: '(esc to clear)',
  customValue: null,
  autoResize: true,
  inputCleanupPattern: null
};
var _default = SearchInput;
exports["default"] = _default;